module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide-act"
  }, [_c('p', [_vm._v("\n    Para cada una de las siguientes situaciones, seleccione el tipo de decisión que ha tomado Juliana, haciendo clic en el elemento de las lista que considere.\n  ")]), _vm._v(" "), (_vm.preguntaNum >= 3) ? _c('div', {
    attrs: {
      "id": "despedida-actdrag",
      "tabindex": "0",
      "role": "alert"
    }
  }, [_c('div', [_vm._v(" ")]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.preguntas), function(pregs, index) {
    return (index === _vm.preguntaNum) ? [_c('div', {
      key: index + 'pregs'
    }, [_c('div', {
      attrs: {
        "id": "preguntaAcc",
        "tabindex": "0"
      }
    }, [_c('p', [_vm._v(_vm._s(pregs.preg))])]), _vm._v(" "), _c('div', [_vm._v(" ")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pregs.resp),
        expression: "pregs.resp"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(pregs, "resp", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "value": ""
      }
    }, [_vm._v("Seleccione una opción")]), _vm._v(" "), _vm._l((_vm.respuestas), function(item) {
      return _c('option', [_vm._v(_vm._s(item.opcion))])
    })], 2)])] : _vm._e()
  }), _vm._v(" "), (_vm.preguntaNum < 3) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.revisar()
      }
    }
  }, [_vm._v("Revisar respuesta")]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "role": "alert",
      "width": "600",
      "height": "200"
    },
    model: {
      value: (_vm.respuesta),
      callback: function($$v) {
        _vm.respuesta = $$v
      },
      expression: "respuesta"
    }
  }, [_c('v-card', [_vm._v("\n      ¡Muy bien!\n      "), _c('v-flex', {
    attrs: {
      "text-xs-center": ""
    }
  }, [_c('ui-button', {
    staticClass: "mt-2 mb-4",
    attrs: {
      "content": 'Cerrar',
      "aria": 'Cerrar'
    },
    nativeOn: {
      "click": function($event) {
        _vm.cerrarRetro()
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "role": "alert",
      "width": "600",
      "height": "200"
    },
    model: {
      value: (_vm.respuestaMal),
      callback: function($$v) {
        _vm.respuestaMal = $$v
      },
      expression: "respuestaMal"
    }
  }, [_c('v-card', [_vm._v("\n      ¡Incorrecto!"), _c('br'), _vm._v(" " + _vm._s(_vm.retroText) + "\n      "), _c('br'), _vm._v(" Inténtelo de nuevo\n\n      "), _c('v-flex', {
    attrs: {
      "text-xs-center": ""
    }
  }, [_c('ui-button', {
    staticClass: "mt-2 mb-4",
    attrs: {
      "content": 'Cerrar',
      "aria": 'Cerrar'
    },
    nativeOn: {
      "click": function($event) {
        _vm.cerrarRetroMal()
      }
    }
  })], 1)], 1)], 1)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      Para tomar decisiones efectivas y alcanzar las metas es importante saber administrar el dinero."), _c('br'), _vm._v(" Puedes continuar con el curso")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6351e084","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actividades/Actividad-drag-back.vue
// module id = 1032
// module chunks = 1